import React from "react";
import PropTypes from "prop-types";
import { NoBorderCard } from "../../../Card";
import { Cell, Row } from "../../../Grid";
import * as styles from "./Cards.module.scss";

const ThingsToDoCards = ({ cards }) =>
	cards && (
		<Row cols="4" totalItems={cards.length}>
			{cards.map((tile, index) => (
				// eslint-disable-next-line react/no-array-index-key
				<Cell key={tile?.id}>
					<NoBorderCard
						key={tile.id}
						image={tile.image}
						className={{ noBorderImage: styles.noBorderImage }}
						header={tile.title}
						link={{
							to: tile.link.to,
							target: "EXTERNAL_MODAL",
							iconPlacement: "right",
							text: tile.link.text || tile.title,
							externalModalMessage: tile.modalMessage,
						}}
						ribbon={index + 1}
					/>
				</Cell>
			))}
		</Row>
	);

ThingsToDoCards.propTypes = {
	cards: PropTypes.arrayOf(PropTypes.object),
};
ThingsToDoCards.defaultProps = {
	cards: [],
};

export default ThingsToDoCards;
export { ThingsToDoCards };
